import { useState } from 'react';
import { NewUserWidget } from '@/components/new-user-widget';
import { Page } from '@/components/page';
import { UsersWidget } from '@/components/users-widget';
import GridLayout, { WidthProvider } from 'react-grid-layout';
import { GridPanel } from '@/components/grid-panel';
import { Toggle } from '@/components/toggle';
import { PermissionsWidget } from '@/components/permissions-widget/permissions-widget';
import { useScreenId } from '@/hooks/use-screen-id';
import { useTabId } from '@/hooks/use-tab-id';
import { EditWidget } from '@/components/edit-widget';

const AutoWidthGridLayout = WidthProvider(GridLayout);

const layout = [
  { i: 'users', x: 0, y: 0, w: 25, h: 20 },
  { i: 'new_user', x: 25, y: 0, w: 15, h: 20 },
  { i: 'permissions', x: 0, y: 20, w: 40, h: 30 },
];

export function ManageOrganisation() {
  const [isDraggable, setIsDraggable] = useState(false);
  const tabId = useTabId();
  const screenId = useScreenId();
  const idPrefix = `${tabId}/${screenId}`;

  if (!tabId || !screenId) {
    return null;
  }

  return (
    <Page 
      title="Manage Organisation"
      toolbar={
        <Toggle
          enabled={isDraggable}
          label="Enable drag"
          onChange={setIsDraggable}
        />
      }
    >
      <AutoWidthGridLayout
        className="layout"
        layout={layout}
          cols={40}
          rowHeight={30}
        isDraggable={isDraggable}
      >
        <GridPanel key="users">
          <UsersWidget id={`${idPrefix}/users`} />
        </GridPanel>
        <GridPanel key="new_user">
          {/* <NewUserWidget id={`${idPrefix}/new_user`} /> */}
          <EditWidget id={`${idPrefix}/edit`} type="user" initalCreateDataClass='270a3927-497d-4497-808f-046bc966da4c' />
        </GridPanel>
        <GridPanel key="permissions">
          <PermissionsWidget id={`${idPrefix}/permissions`} />
        </GridPanel>
      </AutoWidthGridLayout>
    </Page>
  )
} 